import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=d3ab39c4&scoped=true&"
import script from "./Radio.vue?vue&type=script&lang=js&"
export * from "./Radio.vue?vue&type=script&lang=js&"
import style0 from "./Radio.vue?vue&type=style&index=0&id=d3ab39c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ab39c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3ab39c4')) {
      api.createRecord('d3ab39c4', component.options)
    } else {
      api.reload('d3ab39c4', component.options)
    }
    module.hot.accept("./Radio.vue?vue&type=template&id=d3ab39c4&scoped=true&", function () {
      api.rerender('d3ab39c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Radio.vue"
export default component.exports